"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var react_1 = require("react");
var yup_1 = require("@hookform/resolvers/yup");
var react_hook_form_1 = require("react-hook-form");
var react_toastify_1 = require("react-toastify");
var yup = __importStar(require("yup"));
var DialogComponent_1 = __importDefault(require("../../components/DialogComponent"));
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var constants_1 = require("../../constants");
var context_1 = require("../../context");
var hooks_1 = require("../../hooks");
var services_1 = require("../../services");
var utilities_1 = require("../../utilities");
var ModalUpdateCampaignContainer_styled_1 = require("./ModalUpdateCampaignContainer.styled");
var schema = yup
    .object({
    description: yup.string().required('La descripción es obligatoria'),
    cards_quantity: yup
        .number()
        .positive('Debe ser un número positivo')
        .integer('Debe ser un número intero')
        .required('La cantidad de tarjetas es obligatoria'),
    cards_amount: yup
        .number()
        .positive('Debe ser un número positivo')
        .integer('Debe ser un número intero')
        .required('El monto de recarga es obligatoria'),
    cards_currency_code: yup
        .string()
        .required('El tipo de moneda es obligatorio'),
    template_name: yup
        .string()
        .required('El nombre de plantilla del correo es obligatorio'),
    activation_email_send_date: yup
        .date()
        .required('La fecha de envío del correo electrónico de activación es obligatoria')
})
    .required();
function ModalUpdateCampaignContainer(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var onClose = _a.onClose, open = _a.open, campaign = _a.campaign;
    var _j = (0, context_1.useGlobalLoading)(), updateLoading = _j.updateLoading, resetLoading = _j.resetLoading;
    var dateTimeNow = !!campaign.activation_email_send_date && (0, utilities_1.formatDate)({ date: campaign.activation_email_send_date, formatTypeDate: 'yyyy-MM-dd,HH:mm' }).replace(',', 'T');
    var _k = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(schema),
        defaultValues: {
            description: campaign.description,
            cards_quantity: Number(campaign.cards_quantity),
            cards_amount: Number(campaign.cards_amount),
            template_name: (_b = campaign.template_name) !== null && _b !== void 0 ? _b : '',
            activation_email_send_date: !!campaign.activation_email_send_date
                ? (0, utilities_1.formatDate)({
                    date: campaign.activation_email_send_date,
                    formatTypeDate: 'yyyy-MM-dd,HH:mm'
                }).replace(',', 'T')
                : '',
        },
    }), register = _k.register, handleSubmit = _k.handleSubmit, errors = _k.formState.errors, control = _k.control;
    var updateCampaignMutation = (0, hooks_1.useUpdateCampaign)();
    var _l = (0, hooks_1.useGlobalState)(constants_1.GET_DETAIL_CAMPAIGN), setCampaignDetail = _l[1];
    var onSubmit = function (_a) {
        var activation_email_send_date = _a.activation_email_send_date, data = __rest(_a, ["activation_email_send_date"]);
        var activation_email_send_date_input = activation_email_send_date
            ? {
                activation_email_send_date: new Date(activation_email_send_date).toJSON(),
            }
            : {};
        updateCampaignMutation.mutate(__assign({ id: campaign.id, description: data.description, cards_quantity: String(data.cards_quantity), cards_amount: String(data.cards_amount), cards_currency_code: data.cards_currency_code, template_name: data.template_name }, activation_email_send_date_input), {
            onSuccess: function (data) {
                if (data) {
                    var newData = data.data;
                    resetLoading();
                    onClose();
                    services_1.queryClient.invalidateQueries(constants_1.GET_ALL_CAMPAIGNS_FOR_ADMIN);
                    setCampaignDetail(newData);
                    react_toastify_1.toast.success('La campaña se ha editado con éxito');
                }
            },
            onError: function (error) {
                resetLoading();
            },
        });
    };
    var handleCancel = function () {
        onClose();
    };
    (0, react_1.useEffect)(function () {
        if (updateCampaignMutation.isLoading) {
            updateLoading(true);
        }
    }, [updateCampaignMutation.isLoading]);
    return ((0, jsx_runtime_1.jsxs)(DialogComponent_1.default, __assign({ fullWidth: true, onClose: onClose, open: open }, { children: [(0, jsx_runtime_1.jsxs)(ModalUpdateCampaignContainer_styled_1.HeaderContent, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", component: 'h6' }, { children: "Editar Campa\u00F1a" })), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Close, { fontSize: "inherit" }) }))] }), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsx)(ModalUpdateCampaignContainer_styled_1.ContentWrapper, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { display: 'grid', gap: '20px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Descripci\u00F3n", variant: "outlined" }, register('description'), { error: !!errors.description, helperText: (_c = errors.description) === null || _c === void 0 ? void 0 : _c.message })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Cantidad de Tarjetas", variant: "outlined", type: "number" }, register('cards_quantity'), { error: !!errors.cards_quantity, helperText: (_d = errors.cards_quantity) === null || _d === void 0 ? void 0 : _d.message })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Monto de Recarga", variant: "outlined", type: "number" }, register('cards_amount'), { error: !!errors.cards_amount, helperText: (_e = errors.cards_amount) === null || _e === void 0 ? void 0 : _e.message })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ sx: { minWidth: 120 }, error: !!errors.cards_currency_code }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ id: "select_currency" }, { children: "Tipo de Moneda" })), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { render: function (_a) {
                                                var field = _a.field;
                                                return ((0, jsx_runtime_1.jsx)(material_1.Select, __assign({ labelId: "select_currency", id: "select_currency", label: "Tipo de Moneda" }, field, { children: (0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: 'PEN' }, { children: "Soles" })) })));
                                            }, name: "cards_currency_code", control: control, defaultValue: campaign ? campaign.cards_currency_code : 'PEN' }), errors.cards_currency_code && ((0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (_f = errors.cards_currency_code) === null || _f === void 0 ? void 0 : _f.message }))] })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Nombre de Plantilla del Mensaje de Correo", variant: "outlined" }, register('template_name'), { error: !!errors.template_name, helperText: (_g = errors.template_name) === null || _g === void 0 ? void 0 : _g.message })), (0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ label: "Fecha de Env\u00EDo del Correo Electr\u00F3nico de Activaci\u00F3n", variant: "outlined", type: "datetime-local" }, register('activation_email_send_date'), { error: !!errors.activation_email_send_date, helperText: (_h = errors.activation_email_send_date) === null || _h === void 0 ? void 0 : _h.message, InputProps: { inputProps: { min: dateTimeNow } } }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                                marginTop: '20px',
                                display: 'flex',
                                gap: '10px',
                                justifyContent: 'flex-end',
                            } }, { children: [(0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ style: { textTransform: 'uppercase' }, onClick: handleCancel, variant: "outlined", color: "inherit" }, { children: "Cancelar" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", type: "submit" }, { children: updateCampaignMutation.isLoading ? 'Editando...' : 'Editar' }))] }))] })) })] })));
}
exports.default = ModalUpdateCampaignContainer;
